import { DynamicsSettings } from 'app/model/dataflow/dataset-settings/dynamics-settings';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';
import { DatasetFormatType } from 'app/model/dataflow/dataset-settings/dataflow-dataset-settings';
import { Metamodel } from 'shell-models-lib';

@Metamodel.model({
    name: adfModelTypeMap.dynamicsCRM.dataflowSettings
})
export class DynamicsCrmSettings extends DynamicsSettings {
    public getDatasetType(): string {
        return adfModelTypeMap.dynamicsCRM.datasetType;
    }

    public getFormat(): DatasetFormatType {
        return DatasetFormatType.DynamicsCRM;
    }

    public getIconClass(): string {
        return 'i-100x100-dynamics_crm';
    }
}
